import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {PICK_CONSTANTS} from '@gongxigames/framework/slotV2/modules/pick/PickConstants';

const {MINI, MINOR, MAJOR, GRAND} = PICK_CONSTANTS;

export const pickStore = Store.createStore({
    pick_pickedIndex: Store.signal(-1),
    pick_isFinishBonus: Store.signal(true),
    pick_winData: Store.signal(-1),
    pick_winMultiplier: Store.signal(-1),

    pick_jackpotIdsMap: Store.signal(
        new Map<number, string>([
            [13, MINI],
            [14, MINOR],
            [15, MAJOR],
            [16, GRAND],
        ])
    )
});